export default "__VITE_ASSET__XxVul44Y__"